const validateAmount = (amount: string) => {
  const re = /^\d+(.[0-9]{1,2})?$/;
  return re.test(amount);
};

export default validateAmount;
